import React from 'react';
import '../template-file-css/document-file-template.css';


export const CMC_SuperBill = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='CMC_SuperBill' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <h3>
                        {`Shelly Yusuff, M.D., P.C - Super Bill`}
                    </h3>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`Service Code:`}</span>
                    <input type='text' id='txtServiceCode' name='txtServiceCode' placeholder='U1U6' className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Check one:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCheckOne_1' name='cbCheckOne_1' className='add-only' value='CenpaticoPeachState' /> Cenpatico-Peach State
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCheckOne_2' name='cbCheckOne_2' className='add-only' value='AmerigroupPeachCare' /> Amerigroup-Peach Care
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCheckOne_3' name='cbCheckOne_3' className='add-only' value='MedicaidAPS' /> Medicaid-APS
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCheckOne_4' name='cbCheckOne_4' className='add-only' value='StateContracted' /> State Contracted
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCheckOne_5' name='cbCheckOne_5' className='add-only' value='SelfPay' /> Self Pay
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Consumer Name:`}</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>{`ID #:`}</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>{`DOS:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtConsumerName' name='txtConsumerName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtIdOne' name='txtIdOne' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='date' id='txtDateOfService' name='txtDateOfService' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Insurance/MHID:`}</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Service Code:`}</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>{`Units:`}</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>{`# in Group:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtInsuranceMhid' name='txtInsuranceMhid' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtServiceCodeOne' name='txtServiceCodeOne' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtUnits' name='txtUnits' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtInGroup' name='txtInGroup' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Contact Type:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContactType_1' name='cbContactType_1' className='add-only' value='FaceToFace' /> Face to face
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContactType_2' name='cbContactType_2' className='add-only' value='CollateralOther' /> {`Collateral (other)`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContactType_3' name='cbContactType_3' className='add-only' value='PhoneContactClient' /> {`Phone contact-client`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContactType_4' name='cbContactType_4' className='add-only' value='NoCharge' /> No charge
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContactType_5' name='cbContactType_5' className='add-only' value='InClinic' /> {`In-clinic`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContactType_6' name='cbContactType_6' className='add-only' value='OutOfClinic' /> {`Out of clinic`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContactType_7' name='cbContactType_7' className='add-only' value='School' /> School
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContactType_8' name='cbContactType_8' className='add-only' value='Home' /> Home
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContactType_9' name='cbContactType_9' className='add-only' value='Court' /> Court
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContactType_10' name='cbContactType_10' className='add-only' value='ER' /> ER
                        </td>
                        <td className='w-500'>
                            <input type='checkbox' id='cbContactType_12' name='cbContactType_12' className='add-only' value='AttemptedFaceToFace' /> {`Attempted face to face Service Site (for face to face consumers)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbContactType_11' name='cbContactType_11' className='add-only' value='Jail' /> Jail
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbContactType_13' name='cbContactType_13' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtContactTypeOther' name='txtContactTypeOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Diagnostic & Intake services/New consumer.  No PA required.  New Csr for up to 4 or 1 licensed session`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDiagnosticIntakeServices_1' name='cbDiagnosticIntakeServices_1' className='add-only' value='MhpIntakeNewCsr' /> {`MHP-Intake-New Csr - H0031`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDiagnosticIntakeServices_2' name='cbDiagnosticIntakeServices_2' className='add-only' value='MhpHospitalRelAssesNewCsr' /> {`MHP-Hospital Rel Asses-New Csr - H0031`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDiagnosticIntakeServices_3' name='cbDiagnosticIntakeServices_3' className='add-only' value='LicIntakeNewCsr' /> {`LIC Intake-New Csr - 90791`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDiagnosticIntakeServices_4' name='cbDiagnosticIntakeServices_4' className='add-only' value='LicHospitalRelAssessNewCsr' /> {`LIC Hospital Rel Assess-New Csr -  90791`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDiagnosticIntakeServices_5' name='cbDiagnosticIntakeServices_5' className='add-only' value='MhpServicePlanDevelopmentNewCsr' /> {`MHP-Service Plan Development-New Csr (straight Medicaid only) - H0032`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDiagnosticIntakeServices_6' name='cbDiagnosticIntakeServices_6' className='add-only' value='MhpServicePlanDevelopmentStraightMedicaidOnly' /> {`MHP-Service Plan Development (straight Medicaid only) - H0032`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Crisis Management Services/No Prior Authorization Required`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCrisisManagementServices_1' name='cbCrisisManagementServices_1' className='add-only' value='InClinicCrisis' /> {`In-clinic crisis H2011 U1`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCrisisManagementServices_2' name='cbCrisisManagementServices_2' className='add-only' value='OutOfClinicCrisis' /> {`Out of clinic crisis H2011 U2`}
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>{`Outpatient Services/Prior authorization required after 5 Services Episodes`}</h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Family`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbFamily_1' name='cbFamily_1' className='add-only' value='FamilyCouplesTherapyClient' /> {`Family/Couples Therapy w/client LIC - 90847`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFamily_2' name='cbFamily_2' className='add-only' value='FamilyCouplesSkillsTrainingDevelopment' /> {`Family/Couples Skills Training & Development w/client  (Non LIC) - H2014 HR`}
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFamily_3' name='cbFamily_3' className='add-only' value='FamilyCouplesCounselingClient' /> {`Family/Couples Counseling w/client LIC Supv. - H0004 HR`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFamily_4' name='cbFamily_4' className='add-only' value='FamilyCouplesTherapyClientLic' /> {`Family/Couples Therapy w/o client LIC  - 90846`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFamily_5' name='cbFamily_5' className='add-only' value='FamilyCouplesSkillTrainingDevelopment' /> {`Family/Couples Skill Training & Development w/o client (Non LIC) - H2014 HS`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFamily_6' name='cbFamily_6' className='add-only' value='FamilyCouplesCounselingClientLicSupv' /> {`Family/Couples Counseling w/o client LIC Supv. - H0004 HR`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Group`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbGroup_1' name='cbGroup_1' className='add-only' value='GroupTherapyLic' /> {`Group Therapy LIC - 90853`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGroup_2' name='cbGroup_2' className='add-only' value='GroupCounselingLicSupv' /> {`Group Counseling-LIC Supv. - H0004 HQ`}
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGroup_3' name='cbGroup_3' className='add-only' value='GroupSkillTrainingDevelopment' /> {`Group Skill Training & Development (Non Lic) - H2014 HQ`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGroup_4' name='cbGroup_4' className='add-only' value='GroupCounselingFamilyCouplesClientSupv' /> {`Group Counseling-Family/couples w/client LIC  Supv. - H0004 HQ HR`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGroup_5' name='cbGroup_5' className='add-only' value='GroupSkillTrainingDevelopmentFamily' /> {`Group Skill Training & Development Family/couples w/client (Non Lic) - H2014 HQ HR`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGroup_6' name='cbGroup_6' className='add-only' value='GroupCounselingFamilyCouplesHs' /> {`Group counseling-Family/couples w/o client LIC  Supv. - H0004 HQ HS`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbGroup_7' name='cbGroup_7' className='add-only' value='GroupSkillTrainingDevelopmentClientNonLic' /> {`Group Skill Training & Development w/o client (Non LIC) - H2014 HQ HR`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Individual`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbIndividual_1' name='cbIndividual_1' className='add-only' value='IndivTherapyLic' /> {`Indiv. Therapy 30 min. LIC - 90832`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIndividual_2' name='cbIndividual_2' className='add-only' value='IndivTherapyLicFourtyFive' /> {`Indiv. Therapy 45 min. LIC - 90834`}
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIndividual_3' name='cbIndividual_3' className='add-only' value='IndivTherapyLicSixty' /> {`Indiv. Therapy 60 min. LIC - 90837`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIndividual_4' name='cbIndividual_4' className='add-only' value='InteractiveIndivTherapy' /> {`Interactive Indiv. Therapy 20-30 min. LIC - 90810`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIndividual_5' name='cbIndividual_5' className='add-only' value='InteractiveIndivTherapyFourtyFive' /> {`Interactive Indiv. Therapy 45-50 min. LIC - 90812`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIndividual_6' name='cbIndividual_6' className='add-only' value='InteractiveIndivTherapySixty' /> {`Interactive Indiv. Therapy 75-80 min. LIC - 90814`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Nursing Care/Prior Authorization Required`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNursingCarePriorAuthorizationRequired_1' name='cbNursingCarePriorAuthorizationRequired_1' className='add-only' value='NursingAssessmentEvaluation' /> {`Nursing Assessment & Evaluation - T1001`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNursingCarePriorAuthorizationRequired_2' name='cbNursingCarePriorAuthorizationRequired_2' className='add-only' value='NursingAssessmentCareSvcs' /> {`Nursing Assessment & Care (RN Svcs) - T1002`}
                        </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNursingCarePriorAuthorizationRequired_3' name='cbNursingCarePriorAuthorizationRequired_3' className='add-only' value='MedicationAdministrationCenpaticoOnly' /> {`Medication Administration (Cenpatico only) - H2010`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNursingCarePriorAuthorizationRequired_4' name='cbNursingCarePriorAuthorizationRequired_4' className='add-only' value='MedicationAdministartionInjection' /> {`Medication Administration-Injection - 90772`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Physician Services (Authorization Required)`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_1' name='cbPhysicianServicesAuthorizationRquired_1' className='add-only' value='MdAssessmentExtended' /> {`M.D. Assessment/Extended 90792 (90801)`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_2' name='cbPhysicianServicesAuthorizationRquired_2' className='add-only' value='MdAssessmentExtendedCaHa' /> {`M.D. Assessment/Extended C&A 90792 HA`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_3' name='cbPhysicianServicesAuthorizationRquired_3' className='add-only' value='InteractiveMdAssessment' /> {`Interactive M.D. Assessment 90792+90785`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_4' name='cbPhysicianServicesAuthorizationRquired_4' className='add-only' value='InteractiveMdAssessmentCa' /> {`Interactive MD Assessment C&A 90792+90785HA`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_5' name='cbPhysicianServicesAuthorizationRquired_5' className='add-only' value='PsyEmMinEm' /> {`PSY/E&M 20-30 min. - E&M + 90833`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_6' name='cbPhysicianServicesAuthorizationRquired_6' className='add-only' value='PsyEmMinEmHa' /> {`PSY/E&M C&A 20-30 min - E&M + 90833 HA`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_7' name='cbPhysicianServicesAuthorizationRquired_7' className='add-only' value='PsyEmMinEmHaTwo' /> {`PSY/E&M 40-50 min. - E&M + 90836`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_8' name='cbPhysicianServicesAuthorizationRquired_8' className='add-only' value='PsyEmMinEmHaTwoCa' /> {`PSY/E&M C&A 40-50 min - E&M + 90836 HA`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_9' name='cbPhysicianServicesAuthorizationRquired_9' className='add-only' value='MedCheckEm' /> {`Med Check 15 min - E&M`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_10' name='cbPhysicianServicesAuthorizationRquired_10' className='add-only' value='MedCheckEmHa' /> {`Med Check C&A 15 min - E&M HA`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_11' name='cbPhysicianServicesAuthorizationRquired_11' className='add-only' value='IndividualTherapyMinsMdLic' /> {`Individual Therapy 16-37 Mins (MD/Lic) 90832`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_12' name='cbPhysicianServicesAuthorizationRquired_12' className='add-only' value='IndividualTherapyMinsMdLicOne' /> {`Individual Therapy 38-52 Mins (MD/Lic) 90834`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_13' name='cbPhysicianServicesAuthorizationRquired_13' className='add-only' value='IndividualTherapyMinsMdLicTwo' /> {`Individual Therapy 53+ Mins (MD/Lic) 90837`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_14' name='cbPhysicianServicesAuthorizationRquired_14' className='add-only' value='NewPatientEmMins' /> {`New Patient E&M 10-14 Mins 99201 (90862)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_15' name='cbPhysicianServicesAuthorizationRquired_15' className='add-only' value='NewPatientEmMinsOne' /> {`New Patient E&M 15-29 Mins 99202 (90805)`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_16' name='cbPhysicianServicesAuthorizationRquired_16' className='add-only' value='NewPatientEmMinsTwo' /> {`New Patient E&M 30-44 Mins 99203`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_17' name='cbPhysicianServicesAuthorizationRquired_17' className='add-only' value='NewPatientEmMinsThree' /> {`New Patient E&M 45-55 Mins 99204 (90807)`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_19' name='cbPhysicianServicesAuthorizationRquired_19' className='add-only' value='NewPatientEmMinsFive' /> {`New Patient E&M 60-74 Mins 99205`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_20' name='cbPhysicianServicesAuthorizationRquired_20' className='add-only' value='EstPatientEmMins' /> {`Est. Patient E&M 5-9 Mins 99211`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_21' name='cbPhysicianServicesAuthorizationRquired_21' className='add-only' value='EstPatientEmMinsOne' /> {`Est. Patient E&M 10-19 Mins 99212`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_22' name='cbPhysicianServicesAuthorizationRquired_22' className='add-only' value='EstPatientEmMinsTwo' /> {`Est. Patient E&M 20-29 Mins 99213 (90862)`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_23' name='cbPhysicianServicesAuthorizationRquired_23' className='add-only' value='EstPatientEmMinsThree' /> {`Est. Patient E&M 30-39 Mins 99214 (90805)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_24' name='cbPhysicianServicesAuthorizationRquired_24' className='add-only' value='EstPatientEmMinsFour' /> {`Est. Patient E&M 40-54 Mins 99215 (90807)`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_25' name='cbPhysicianServicesAuthorizationRquired_25' className='add-only' value='IndividualPsychotherapyEmMins' /> {`Indiv. Psychotherapy w/ E&M 30 Mins 90833`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_26' name='cbPhysicianServicesAuthorizationRquired_26' className='add-only' value='IndividualPsychotherapyEmMinsOne' /> {`Indiv. Psychotherapy w/ E&M 45 Mins 90836`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_27' name='cbPhysicianServicesAuthorizationRquired_27' className='add-only' value='FamPsychotherapyWoPatient' /> {`Fam Psychotherapy w/o patient 90846`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_28' name='cbPhysicianServicesAuthorizationRquired_28' className='add-only' value='FamilyPsychotherapyWithPatient' /> {`Family Psychotherapy with patient 90847`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPhysicianServicesAuthorizationRquired_29' name='cbPhysicianServicesAuthorizationRquired_29' className='add-only' value='GroupPsychotherapy' /> {`Group Psychotherapy 90853`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Abuse/Neglect`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAbuseNeglect_1' name='cbAbuseNeglect_1' className='add-only' value='NeglectChildIfFocusAttention' /> {`T74.02XA Neglect of Child (if focus of attention is on victim)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAbuseNeglect_2' name='cbAbuseNeglect_2' className='add-only' value='SexualAbuseOfChildIfFocusAttention' /> {`T74.22XA Sexual Abuse of Child (if focus of attention is on victim`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAbuseNeglect_3' name='cbAbuseNeglect_3' className='add-only' value='PhysicalAbuseOfChildIfFocusAttention' /> {`T74.12XA Physical Abuse of Child (if focus of attention is on victim)`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`ADHD`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdhd_1' name='cbAdhd_1' className='add-only' value='AdhdPredminantlyInattentiveType' /> {`F90.0 ADHD predominantly inattentive type`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdhd_2' name='cbAdhd_2' className='add-only' value='AdhdCombinedType' /> {`F90.2 ADHD combined type`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdhd_3' name='cbAdhd_3' className='add-only' value='AdhdPredominantlyHyperactiveImpulsive' /> {`F90.1 ADHD predominantly hyperactive impulsive`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdhd_4' name='cbAdhd_4' className='add-only' value='AttentionDeficitHyperactivityDisorderNos' /> {`F90.9 Attention Deficit/Hyperactivity disorder NOS`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Adjustment Disorder`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdjustmentDisorder_1' name='cbAdjustmentDisorder_1' className='add-only' value='AdjDisorderDepressedMood' /> {`F43.21 Adj. disorder with depressed mood`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdjustmentDisorder_2' name='cbAdjustmentDisorder_2' className='add-only' value='SeparationAnxietyDisorderChild' /> {`F93.0 Separation Anxiety Disorder Child`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdjustmentDisorder_3' name='cbAdjustmentDisorder_3' className='add-only' value='AdjDisorderWithAnxiety' /> {`F43.22 Adj. disorder with anxiety`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdjustmentDisorder_5' name='cbAdjustmentDisorder_5' className='add-only' value='AdjDisorderWithDisturbanceConduct' /> {`F43.24 Adj. disorder with disturbance of  conduct`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdjustmentDisorder_7' name='cbAdjustmentDisorder_7' className='add-only' value='AdjDisorderUnspecifiedV' /> {`F43.20 Adj. disorder unspecified`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAdjustmentDisorder_8' name='cbAdjustmentDisorder_8' className='add-only' value='PosttraumaticStressDisorder' /> {`F43.10 Posttraumatic Stress Disorder`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAdjustmentDisorder_9' name='cbAdjustmentDisorder_9' className='add-only' value='SelectiveMutism' /> {`F94.0 Selective Mutism`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAdjustmentDisorder_6' name='cbAdjustmentDisorder_6' className='add-only' value='AdjDisorderWithDisturbanceEmotionsAndConduct' /> {`F43.25 Adj. disorder with disturbance of  emotions and conduct`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAdjustmentDisorder_4' name='cbAdjustmentDisorder_4' className='add-only' value='AdjDisorderWithMixedAnxietyAndDepression' /> {`F43.23 Adj. disorder with mixed anxiety and  depression`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Bipolar`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBipolar_1' name='cbBipolar_1' className='add-only' value='BipolarIDisorderSingleManicEpisode' /> {` F31.0 Bipolar I Disorder Single Manic Episode`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBipolar_2' name='cbBipolar_2' className='add-only' value='BipolarIDisorderMostRecentManic' /> {`F31.10 Bipolar I Disorder most recent Manic`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBipolar_3' name='cbBipolar_3' className='add-only' value='BipolarIDisorderMostRecentManicSeverePsychotic' /> {`F31.20 Bipolar I Disorder most recent Manic severe w/psychotic features`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBipolar_4' name='cbBipolar_4' className='add-only' value='BipolarIDisorderMostRecentDepressed' /> {`F31.30 Bipolar I Disorder most recent Depressed`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBipolar_7' name='cbBipolar_7' className='add-only' value='BipolarIDisorderMostRecentMixed' /> {`F31.62 Bipolar I Disorder I most recent Mixed`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBipolar_8' name='cbBipolar_8' className='add-only' value='BipolarIDisorderMostRecentMixedUnspecified' /> {`F31.60 Bipolar I Disorder most recent Mixed Unspecified`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBipolar_9' name='cbBipolar_9' className='add-only' value='BipolarIDisorderNos' /> {`F31.90 Bipolar I Disorder NOS`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBipolar_6' name='cbBipolar_6' className='add-only' value='BipolarIiDisorder' /> {`F31.81 Bipolar II Disorder`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBipolar_5' name='cbBipolar_5' className='add-only' value='CyclothymicDisorder' /> {`F34.0 Cyclothymic Disorder`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Conduct Disorder`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbConductDisorder_1' name='cbConductDisorder_1' className='add-only' value='ConductDisorderConfinedFamilyContext' /> {`F91.0 Conduct Disorder confined to family context`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbConductDisorder_2' name='cbConductDisorder_2' className='add-only' value='ConductDisorderChildhoodOnsetType' /> {`F91.1 Conduct disorder childhood onset type`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbConductDisorder_3' name='cbConductDisorder_3' className='add-only' value='ConductDisorderAdolescentOnsetType' /> {`F91.2 Conduct disorder adolescent onset type`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbConductDisorder_4' name='cbConductDisorder_4' className='add-only' value='DisruptiveBehaviorDisorderNos' /> {`F91.9 Disruptive behavior disorder NOS`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbConductDisorder_7' name='cbConductDisorder_7' className='add-only' value='OppositionalDefiantDisorderDepression' /> {`F91.3 Oppositional Defiant Disorder Depression`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbConductDisorder_8' name='cbConductDisorder_8' className='add-only' value='MajorDepressiveDisorderSingleEpisodeUnspecified' /> {`F32.9 Major depressive disorder single episode Unspecified`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbConductDisorder_9' name='cbConductDisorder_9' className='add-only' value='MajorDepressiveDisorderSingleEpisodeSeverePsychoticFeatures' /> {`F32.3 Major depressive disorder single episode severe w/psychotic features`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbConductDisorder_6' name='cbConductDisorder_6' className='add-only' value='MajorDepressiveDisorderRecurrentUnspecified' /> {`F33.9 Major depressive disorder recurrent, unspecified`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbConductDisorder_5' name='cbConductDisorder_5' className='add-only' value='MoodDisorderNos' /> {`F39 Mood Disorder, NOS`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbConductDisorder_10' name='cbConductDisorder_10' className='add-only' value='DysthymicDisorder' /> {`F34.1 Dysthymic Disorder`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbConductDisorder_11' name='cbConductDisorder_11' className='add-only' value='DepressiveDisorderNOS' /> {`F32.9 Depressive Disorder NOS`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Eating`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEating_1' name='cbEating_1' className='add-only' value='BodyDysmorphicDisorder' /> {`F45.22 Body Dysmorphic disorder`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEating_2' name='cbEating_2' className='add-only' value='AnorexiaNervosa' /> {`F50.00 Anorexia Nervosa`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEating_3' name='cbEating_3' className='add-only' value='EatingDisorderNos' /> {`F50.9 Eating Disorder NOS`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEating_4' name='cbEating_4' className='add-only' value='BulimiaNervosa' /> {`F50.2 Bulimia Nervosa`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Motor`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMotor_1' name='cbMotor_1' className='add-only' value='TicDisorderNos' /> {`F95.9 Tic disorder NOS`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMotor_2' name='cbMotor_2' className='add-only' value='TourettesDisorder' /> {`F95.2 Tourette's Disorder`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMotor_3' name='cbMotor_3' className='add-only' value='TrichotillomaniaImpulse' /> {`F63.3 Trichotillomania Impulse`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMotor_4' name='cbMotor_4' className='add-only' value='Disorganizedschizophrenia' /> {`F20.1 Disorganized schizophrenia`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMotor_5' name='cbMotor_5' className='add-only' value='PsychoticDisorderNOS' /> {`F29 Psychotic Disorder NOS`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMotor_6' name='cbMotor_6' className='add-only' value='AspergersDisorder' /> {`F84.5 Asperger's Disorder`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Anxiety`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAnxiety_1' name='cbAnxiety_1' className='add-only' value='AnxietyUnspecified' /> {`F41.9 Anxiety Unspecified`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAnxiety_2' name='cbAnxiety_2' className='add-only' value='PanicDisorderwoAgoraphobia' /> {`F41.0 Panic Disorder (w/o Agoraphobia)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAnxiety_3' name='cbAnxiety_3' className='add-only' value='GeneralizedAnxietyDisorder' /> {`F41.1 Generalized Anxiety Disorder`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAnxiety_4' name='cbAnxiety_4' className='add-only' value='SocialPhobiaAnxiety' /> {`F40.10 Social Phobia Anxiety`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAnxiety_5' name='cbAnxiety_5' className='add-only' value='SpecificPhobiaAnxiety' /> {`F40.8 Specific Phobia Anxiety`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAnxiety_6' name='cbAnxiety_6' className='add-only' value='ObsessiveCompulsiveDisorder' /> {`F42.0 Obsessive-compulsive Disorder`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Quantitative review-note present/note match?`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbQuantitativeReviewPresentNote_Yes' name='rbQuantitativeReviewPresentNote' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbQuantitativeReviewPresentNote_No' name='rbQuantitativeReviewPresentNote' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Eligible?`}</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Initial & Date?`}</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>{`due`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtEligible' name='txtEligible' className='add-only' />
                        </td>
                        <td className='w-250'><input type='date' id='txtInitialDate' name='txtInitialDate' className='add-only' />
                        </td>
                        <td className='w-250'><input type='date' id='txtDue' name='txtDue' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-175'>
                            <span className='eleHeader'>{`Date Entry Staff Initial:`}</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>{`Date:`}</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>{`Receipt #:`}</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>{`Cash/charge/check #:`}</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>{`Paid $`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-175'><input type='date' id='txtDateEntryStaffInitial' name='txtDateEntryStaffInitial' className='add-only' />
                        </td>
                        <td className='w-150'><input type='date' id='txtDate_2' name='txtDate_2' className='add-only' />
                        </td>
                        <td className='w-125'>
                            <input type='text' id='txtReceipt' name='txtReceipt' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtCashChargeCheck' name='txtCashChargeCheck' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtPaid' name='txtPaid' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Notes:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtNotes' name='txtNotes' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Return in:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='radio' id='rbReturnIn_Weeks' name='rbReturnIn' className='add-only' value='Weeks' /> 2 weeks
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbReturnIn_MonthOne' name='rbReturnIn' className='add-only' value='MonthOne' /> 1 month
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbReturnIn_WeeksSix' name='rbReturnIn' className='add-only' value='WeeksSix' /> 6 weeks
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbReturnIn_MonthTwo' name='rbReturnIn' className='add-only' value='MonthTwo' /> 2 months
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbReturnIn_MonthThree' name='rbReturnIn' className='add-only' value='MonthThree' /> 3 months
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Refer for:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbReferFor_Individual' name='rbReferFor' className='add-only' value='Individual' /> Individual
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbReferFor_Family' name='rbReferFor' className='add-only' value='Family' /> Family
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbReferFor_Group' name='rbReferFor' className='add-only' value='Group' /> Group
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbReferFor_Nursing' name='rbReferFor' className='add-only' value='Nursing' /> Nursing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbReferFor_IFI' name='rbReferFor' className='add-only' value='IFI' /> IFI
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbReferFor_Physician' name='rbReferFor' className='add-only' value='Physician' /> Physician
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbReferFor_NeedCapResults' name='rbReferFor' className='add-only' value='NeedCapResults' /> Need Cap Results
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbReferFor_LabsOrdered' name='rbReferFor' className='add-only' value='LabsOrdered' /> Labs Ordered
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbReferFor_CSI' name='rbReferFor' className='add-only' value='CSI' /> CSI
                        </td>
                        <td className='w-500'>
                            <input type='radio' id='rbReferFor_NeedLabResultsForNextVisit' name='rbReferFor' className='add-only' value='NeedLabResultsForNextVisit' /> Need Lab Results for Next Visit
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Approved for:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbApprovedFor_Individual' name='rbApprovedFor' className='add-only' value='Individual' /> Individual
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbApprovedFor_Family' name='rbApprovedFor' className='add-only' value='Family' /> Family
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbApprovedFor_Group' name='rbApprovedFor' className='add-only' value='Group' /> Group
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbApprovedFor_Nursing' name='rbApprovedFor' className='add-only' value='Nursing' /> Nursing
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbApprovedFor_CSI' name='rbApprovedFor' className='add-only' value='CSI' /> CSI
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbApprovedFor_IFI' name='rbApprovedFor' className='add-only' value='IFI' /> IFI
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbApprovedFor_Physician' name='rbApprovedFor' className='add-only' value='Physician' /> Physician
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Next appointment:</td>
                        <td className='small w-375'> Signed: </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>Psychiatric Progress Note
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Start Time:`}</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>{`End Time`}</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Medication Name`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='time' id='txtStartTimeOne' name='txtStartTimeOne' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='time' id='txtEndTimeOne' name='txtEndTimeOne' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtMedicationName_1' name='txtMedicationName_1' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-150'>
                            <span className='eleHeader'>{`Date/schedule`}</span>
                        </td>
                        <td className='w-600'>
                            <span className='eleHeader'>{`Titration, duration to take, if new or counting,start/stop, other pertinent information`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='text' id='txtDateSchedule_1' name='txtDateSchedule_1' className='add-only' />
                        </td>
                        <td className='w-600'>
                            <input type='text' id='txtTitrationDurationTake_1' name='txtTitrationDurationTake_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Indication for use`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='small'>  <b>{`*Circle all that apply: S= Targeted core Syndrome OS= Targeted @ other symptoms SE= for side effects of S or OS`}</b></span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-80'>
                            <input type='checkbox' id='cbIndicationForUse_1' name='cbIndicationForUse_1' className='add-only' value='SOne' /> {`S`}
                        </td>
                        <td className='w-80'>
                            <input type='checkbox' id='cbIndicationForUse_2' name='cbIndicationForUse_2' className='add-only' value='Os' /> {`OS`}
                        </td>
                        <td className='w-80'>
                            <input type='checkbox' id='cbIndicationForUse_3' name='cbIndicationForUse_3' className='add-only' value='Se' /> {`SE`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Compliance`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbCompliance_Full' name='rbCompliance' className='add-only' value='Full' /> Full
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbCompliance_Partial' name='rbCompliance' className='add-only' value='Partial' /> partial
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbCompliance_Poor' name='rbCompliance' className='add-only' value='Poor' /> poor
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'>{`Labs (with date):`}</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'>{`Wt change`}</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>{`WT`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-300'>
                            <input type='text' id='txtLabsWithDate' name='txtLabsWithDate' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbWeightChange_Gain' name='rbWeightChange' className='add-only' value='Gain' /> GAin
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbWeightChange_Loss' name='rbWeightChange' className='add-only' value='Loss' /> Loss
                        </td>
                        <td className='w-100'>&nbsp;</td>
                        <td className='w-100'>
                            <input type='text' id='txtWeightAmounts' name='txtWeightAmounts' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-300'>
                            <span className='eleHeader'>{`Side effect:`}</span>
                        </td>
                        <td className='w-450'>
                            <span className='eleHeader'>{`AIMS- (every 6 mo) Completed`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbSideEffect_Yes' name='rbSideEffect' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbSideEffect_No' name='rbSideEffect' className='add-only' value='No' /> No
                        </td>
                        <td className='w-100'>&nbsp;</td>
                        <td className='w-100'>
                            <input type='radio' id='rbAimsCompleted_Yes' name='rbAimsCompleted' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbAimsCompleted_No' name='rbAimsCompleted' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>{`Pt showed up with Parents/mother/father/foster parent/legal guardian`}</span>
                    <textarea id='txtMedicalHistory' name='txtMedicalHistory' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>
                        {`Symptoms:`}
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>{`Compliant with meds?`}</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>{`Changes in appetite?`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbComplaintWithNeds_Yes' name='rbComplaintWithNeds' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbComplaintWithNeds_No' name='rbComplaintWithNeds' className='add-only' value='No' /> No
                        </td>
                        <td className='w-175'>&nbsp;</td>
                        <td className='w-100'>
                            <input type='radio' id='rbChangeInAppetite_Yes' name='rbChangeInAppetite' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbChangeInAppetite_No' name='rbChangeInAppetite' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>{`Current stressors/triggers:`}</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>{`Grades/Suspensions/Expulsion:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCurrentStressorsTrigers' name='txtCurrentStressorsTrigers' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtGradesSuspensionExpulsion' name='txtGradesSuspensionExpulsion' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-465'>
                            <span className='eleHeader'>{`Overall symptom improvement:`}</span>
                        </td>
                        <td className='w-285'>
                            <span className='eleHeader'>{`Grades are:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbOverallSymptomImprovement_Worse' name='rbOverallSymptomImprovement' className='add-only' value='Worse' /> Worse
                        </td>
                        <td className='w-80'>
                            <input type='radio' id='rbOverallSymptomImprovement_Poor' name='rbOverallSymptomImprovement' className='add-only' value='Poor' /> Poor
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbOverallSymptomImprovement_Minimal' name='rbOverallSymptomImprovement' className='add-only' value='Minimal' /> Minimal
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbOverallSymptomImprovement_Moderate' name='rbOverallSymptomImprovement' className='add-only' value='Moderate' /> Moderate
                        </td>
                        <td className='w-85'>
                            <input type='radio' id='rbOverallSymptomImprovement_Full' name='rbOverallSymptomImprovement' className='add-only' value='Full' /> Full
                        </td>
                        <td className='w-285'>
                            <input type='text' id='txtGradesInOne' name='txtGradesInOne' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        {`Complaints:`}
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Active Substance use?`}</span>
                        </td>
                        <td className='w-500'>
                            <span className='eleHeader'>{`Teacher complaints:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbActiveSubstanceUse_Yes' name='rbActiveSubstanceUse' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbActiveSubstanceUse_No' name='rbActiveSubstanceUse' className='add-only' value='No' /> No
                        </td>
                        <td className='w-50'>&nbsp;</td>
                        <tr>
                            <td className='w-100'>
                                <input type='radio' id='rbTeacherComplaints_Good' name='rbTeacherComplaints' className='add-only' value='Good' /> Good
                            </td>
                            <td className='w-100'>
                                <input type='radio' id='rbTeacherComplaints_Poor' name='rbTeacherComplaints' className='add-only' value='Poor' /> poor
                            </td>
                            <td className='w-250'>
                                <input type='radio' id='rbTeacherComplaints_FairResponseToMeds' name='rbTeacherComplaints' className='add-only' value='FairResponseToMeds' /> Fair response to meds
                            </td>
                        </tr>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>
                        {`Change in attitude:`}
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>{`Takes meds on weekends?`}</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>{`Changes in Sleep pattern?`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbTakesMedOnWeekends_Yes' name='rbTakesMedOnWeekends' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbTakesMedOnWeekends_No' name='rbTakesMedOnWeekends' className='add-only' value='No' /> No
                        </td>
                        <td className='w-175'>&nbsp;</td>
                        <td className='w-100'>
                            <input type='radio' id='rbChangesInSleepPattern_Yes' name='rbChangesInSleepPattern' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbChangesInSleepPattern_No' name='rbChangesInSleepPattern' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <h3>CURRENT MENTAL STATUS
                    </h3>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Orientation`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbOrientation_1' name='cbOrientation_1' className='add-only' value='OrientedX' /> {`Oriented X4`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='checkbox' id='cbOrientation_2' name='cbOrientation_2' className='add-only' value='DisorientedTo' /> {`Disoriented to:`}
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDisorientedTo_Person' name='rbDisorientedTo' className='add-only' value='Person' /> Person
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDisorientedTo_Situation' name='rbDisorientedTo' className='add-only' value='Situation' /> Situation
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDisorientedTo_Place' name='rbDisorientedTo' className='add-only' value='Place' /> Place
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDisorientedTo_Time' name='rbDisorientedTo' className='add-only' value='Time' /> Time
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Affect`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_1' name='cbAffect_1' className='add-only' value='Normal' /> {`Normal`}
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_2' name='cbAffect_2' className='add-only' value='Labile' /> {`Labile`}
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_3' name='cbAffect_3' className='add-only' value='Flat' /> {`Flat`}
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_5' name='cbAffect_5' className='add-only' value='Angry' /> {`Angry`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_6' name='cbAffect_6' className='add-only' value='Elated' /> {`Elated`}
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_7' name='cbAffect_7' className='add-only' value='Depressed' /> {`Depressed`}
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_8' name='cbAffect_8' className='add-only' value='Anxious' /> {`Anxious`}
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_9' name='cbAffect_9' className='add-only' value='Manic' /> {`Manic`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_10' name='cbAffect_10' className='add-only' value='Fidgety' /> {`Fidgety`}
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAffect_12' name='cbAffect_12' className='add-only' value='Hyperactive' /> {`Hyperactive`}
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbAffect_11' name='cbAffect_11' className='add-only' value='InappropriateToThought' /> {`Inappropriate to thought`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAffect_12' name='cbAffect_12' className='add-only' value='ElevatedEyeBlinking' /> {`Elevated eye blinking`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Thought`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThought_1' name='cbThought_1' className='add-only' value='Rational' /> {`Rational`}
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThought_2' name='cbThought_2' className='add-only' value='Delusional' /> {`Delusional`}
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThought_3' name='cbThought_3' className='add-only' value='Tangential' /> {`Tangential`}
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThought_4' name='cbThought_4' className='add-only' value='Loose' /> {`Loose`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThought_5' name='cbThought_5' className='add-only' value='Blocking' /> {`Blocking`}
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThought_6' name='cbThought_6' className='add-only' value='Circumstantial' /> {`Circumstantial`}
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThought_8' name='cbThought_8' className='add-only' value='Denies' /> {`DENIES`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThought_7' name='cbThought_7' className='add-only' value='Hallucination' /> {`Hallucination`}
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbThought_Audio' name='rbThought' className='add-only' value='Audio' /> Audio
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbThought_Visual' name='rbThought' className='add-only' value='Visual' /> Visual
                        </td>
                        <td className='w-313'>
                            <input type='radio' id='rbThought_Other' name='rbThought' className='add-only' value='Other' /> Other
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Suicidal/Homicidal Risk`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbSuicidalHomicidalRisk_1' name='cbSuicidalHomicidalRisk_1' className='add-only' value='Suicidal' /> {`Suicidal`}
                        </td>
                    </tr>
                    <tr>
                        <ul> <td className='w-150'>
                            <input type='checkbox' id='cbSuicidalHomicidalRisk_2' name='cbSuicidalHomicidalRisk_2' className='add-only' value='Thought' /> {`Thought`}
                        </td>
                            <td className='w-150'>
                                <input type='checkbox' id='cbSuicidalHomicidalRisk_3' name='cbSuicidalHomicidalRisk_3' className='add-only' value='Plan' /> {`Plan`}
                            </td>
                            <td className='w-150'>
                                <input type='checkbox' id='cbSuicidalHomicidalRisk_4' name='cbSuicidalHomicidalRisk_4' className='add-only' value='Attempt' /> {`Attempt`}
                            </td>
                            <td className='w-150'>
                                <input type='checkbox' id='cbSuicidalHomicidalRisk_5' name='cbSuicidalHomicidalRisk_5' className='add-only' value='None' /> {`None`}
                            </td></ul>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbHomicidalRisk_1' name='cbHomicidalRisk_1' className='add-only' value='Homicidal' /> {`Homicidal`}
                        </td>
                    </tr>
                    <tr>
                        <ul> <td className='w-150'>
                            <input type='checkbox' id='cbHomicidalRisk_2' name='cbHomicidalRisk_2' className='add-only' value='Thought' /> {`Thought`}
                        </td>
                            <td className='w-150'>
                                <input type='checkbox' id='cbHomicidalRisk_3' name='cbHomicidalRisk_3' className='add-only' value='Plan' /> {`Plan`}
                            </td>
                            <td className='w-150'>
                                <input type='checkbox' id='cbHomicidalRisk_4' name='cbHomicidalRisk_4' className='add-only' value='Attempt' /> {`Attempt`}
                            </td>
                            <td className='w-150'>
                                <input type='checkbox' id='cbHomicidalRisk_5' name='cbHomicidalRisk_5' className='add-only' value='None' /> {`None`}
                            </td></ul>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Appearance`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_1' name='cbAppearance_1' className='add-only' value='Appropriate' /> {`Appropriate`}
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_2' name='cbAppearance_2' className='add-only' value='Disheveled' /> {`Disheveled`}
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_3' name='cbAppearance_3' className='add-only' value='PoorHygiene' /> {`Poor Hygiene`}
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_4' name='cbAppearance_4' className='add-only' value='WellNourished' /> {`Well Nourished`}
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_5' name='cbAppearance_5' className='add-only' value='WellGroomed' /> {`Well Groomed`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_6' name='cbAppearance_6' className='add-only' value='Bizarre' /> {`Bizarre`}
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbAppearance_7' name='cbAppearance_7' className='add-only' value='GoodHygiene' /> {`Good Hygiene`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Other`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOtherOne_1' name='cbOtherOne_1' className='add-only' value='Cooperative' /> {`Cooperative`}
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOtherOne_2' name='cbOtherOne_2' className='add-only' value='Uncooperative' /> {`Uncooperative`}
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOtherOne_3' name='cbOtherOne_3' className='add-only' value='Aggressive' /> {`Aggressive`}
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOtherOne_4' name='cbOtherOne_4' className='add-only' value='Withdrawn' /> {`Withdrawn`}
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOtherOne_5' name='cbOtherOne_5' className='add-only' value='Agitated' /> {`Agitated`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOtherOne_6' name='cbOtherOne_6' className='add-only' value='SlurredSpeech' /> {`Slurred Speech`}
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOtherOne_7' name='cbOtherOne_7' className='add-only' value='RapidSpeech' /> {`Rapid Speech`}
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOtherOne_8' name='cbOtherOne_8' className='add-only' value='Normal' /> {`Normal`}
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOtherOne_11' name='cbOtherOne_11' className='add-only' value='ImpairedSpeech' /> {`Impaired Speech`}
                        </td>
                        <td className='w-150'>
                            <input type='checkbox' id='cbOtherOne_10' name='cbOtherOne_10' className='add-only' value='ImpairedMemory' /> {`Impaired Memory`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherOne_9' name='cbOtherOne_9' className='add-only' value='ImpairedJudgment' /> {`Impaired Judgment`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`PLAN /RX:`}</span>
                            <span className='small'>{`(if any changes indicate reason): Discussed various coping skills and behavior management?`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbPlanRxOne_Yes' name='rbPlanRxOne' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbPlanRxOne_No' name='rbPlanRxOne' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtIfAnyChangesIndicateOne' name='txtIfAnyChangesIndicateOne' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Attempt to taper medication? `}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbAttemptTaperMedication_Yes' name='rbAttemptTaperMedication' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbAttemptTaperMedication_No' name='rbAttemptTaperMedication' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Educated about risks of medication:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducatedAboutRiskOfMedication_1' name='cbEducatedAboutRiskOfMedication_1' className='add-only' value='Appetite' /> {`↓Appetite`}
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbEducatedAboutRiskOfMedication_2' name='cbEducatedAboutRiskOfMedication_2' className='add-only' value='Sleep' /> {`↓Sleep`}
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='cbEducatedAboutRiskOfMedication_3' name='cbEducatedAboutRiskOfMedication_3' className='add-only' value='NauseaVomitingFatigueSedation' /> {`Nausea/Vomiting/Fatigue/Sedation`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducatedAboutRiskOfMedication_4' name='cbEducatedAboutRiskOfMedication_4' className='add-only' value='Heartbeat' /> {`↑Heartbeat`}
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbEducatedAboutRiskOfMedication_5' name='cbEducatedAboutRiskOfMedication_5' className='add-only' value='Palpitations' /> {`↑Palpitations`}
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='cbEducatedAboutRiskOfMedication_6' name='cbEducatedAboutRiskOfMedication_6' className='add-only' value='Dizziness' /> {`Dizziness`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducatedAboutRiskOfMedication_7' name='cbEducatedAboutRiskOfMedication_7' className='add-only' value='BP' /> {`↓BP`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Educated about benefits of medication:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducatedAboutBenifitsOfMedication_1' name='cbEducatedAboutBenifitsOfMedication_1' className='add-only' value='ImprovedMood' /> {`Improved Mood`}
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbEducatedAboutBenifitsOfMedication_2' name='cbEducatedAboutBenifitsOfMedication_2' className='add-only' value='ImprovedFocus' /> {`Improved Focus`}
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='cbEducatedAboutBenifitsOfMedication_3' name='cbEducatedAboutBenifitsOfMedication_3' className='add-only' value='ImprovedGrades' /> {`Improved Grades`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Education on different coping skills:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducationOnDifferentCopingSkills_1' name='cbEducationOnDifferentCopingSkills_1' className='add-only' value='Counting' /> {`Counting`}
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbEducationOnDifferentCopingSkills_2' name='cbEducationOnDifferentCopingSkills_2' className='add-only' value='Talking' /> {`Talking`}
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='cbEducationOnDifferentCopingSkills_3' name='cbEducationOnDifferentCopingSkills_3' className='add-only' value='Journaling' /> {`Journaling`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEducationOnDifferentCopingSkills_4' name='cbEducationOnDifferentCopingSkills_4' className='add-only' value='CBTExercise' /> {`CBT Exercise`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbEducationOnDifferentCopingSkills_5' name='cbEducationOnDifferentCopingSkills_5' className='add-only' value='RenewAdjustChangeCurrentMedication' /> {`Renew/Adjust/Change current medication x1 month Rx,`}&nbsp;<input type='text' id='txtProviderName_' name='txtProviderName_' className='add-only w-150 custom-add-only' /> refills
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbEducationOnDifferentCopingSkills_6' name='cbEducationOnDifferentCopingSkills_6' className='add-only' value='PatientFamilyVerbalizedUnderstandingClientVerbalizes' /> {`Rx given - Patient/family verbalized understanding Client verbalizes/ understands to call 911, walk in the ER, or call`}
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>crisis line if symptoms worsen of if the client feels SI/HI</span>
                    <input type='radio' id='rbCrisisLineSymptons_Yes' name='rbCrisisLineSymptons' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCrisisLineSymptons_No' name='rbCrisisLineSymptons' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Inform Consent sheet completed</span>
                    <input type='radio' id='rbInformConsentSheetCompleted_Yes' name='rbInformConsentSheetCompleted' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbInformConsentSheetCompleted_No' name='rbInformConsentSheetCompleted' className='add-only' value='No' /> No
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Medication(s):`}</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Refill(s):`}</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>{`Discontinue Med(s):`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='radio' id='rbMedicationsOne_Yes' name='rbMedicationsOne' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbMedicationsOne_No' name='rbMedicationsOne' className='add-only' value='No' /> No
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbRefillsOne_Yes' name='rbRefillsOne' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbRefillsOne_No' name='rbRefillsOne' className='add-only' value='No' /> No
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDiscontinueMeds_Yes' name='rbDiscontinueMeds' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-125'>
                            <input type='radio' id='rbDiscontinueMeds_No' name='rbDiscontinueMeds' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type='checkbox' id='cbCheckBox_7' name='cbCheckBox_7' className='add-only' value='One' /> {``}&nbsp;<input type='text' id='txtCheckBoxOne' name='txtCheckBoxOne' className='add-only w-40 custom-add-only' />&nbsp;{`% of time dedicated to counseling and/or coordinating care as listed below (must be ≥ 50% for time based E & M billing):`}
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>{`Interventions this visit:`}</span>
                    <textarea id='txtInterventionThisVisit' name='txtInterventionThisVisit' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Counseling`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCounseling_1' name='cbCounseling_1' className='add-only' value='ProvidedEducationOnDiagnosis' /> {`Provided education on diagnosis (Tics with Adderall)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCounseling_2' name='cbCounseling_2' className='add-only' value='DiscussedPrognosis' /> {`Discussed prognosis`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCounseling_3' name='cbCounseling_3' className='add-only' value='DiscussedImportanceBarriers' /> {`Discussed importance/barriers to medication adherence`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCounseling_4' name='cbCounseling_4' className='add-only' value='DiscussedRiskBenefitsOf' /> {`Discussed risk/benefits of medication/treatment options`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCounseling_5' name='cbCounseling_5' className='add-only' value='DiscussedMedicationSideEffects' /> {`Discussed medication side effects`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCounseling_6' name='cbCounseling_6' className='add-only' value='DiscussedPotentialForMetabolic' /> {`Discussed potential for metabolic effects/need for monitoring`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCounseling_7' name='cbCounseling_7' className='add-only' value='DiscussedDietExerciseToManage' /> {`Discussed diet/exercise to manage metabolic effects`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCounseling_8' name='cbCounseling_8' className='add-only' value='ProvidedInstructionsShould' /> {`Provided instructions should patient become pregnant`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCounseling_9' name='cbCounseling_9' className='add-only' value='EducationOnTardiveDyskinesia' /> {`Education on Tardive Dyskinesia risk v. benefits of treatment`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCounseling_10' name='cbCounseling_10' className='add-only' value='RiskFactorReduction' /> {`Risk factor reduction`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Medical`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMedical_1' name='cbMedical_1' className='add-only' value='ReviewedLabsTestResults' /> {`Reviewed Labs/Test Results with patient`}

                        </td>
                    </tr>
                    <tr>
                        <td className='w-280'>
                            <input type='checkbox' id='cbMedical_1' name='cbMedical_1' className='add-only' value='RatingScalesieCorner' /> {`Rating Scales/ie Corner, beck, etc...`}
                        </td>
                        <td className='w-100'>
                            Done
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbDiscontinueMedsOne_Yes' name='rbDiscontinueMedsOne' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbDiscontinueMedsOne_No' name='rbDiscontinueMedsOne' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Therapy/Behavioral`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTherapyBehavioral_1' name='cbTherapyBehavioral_1' className='add-only' value='AssistedWithProblemSolvingGoal' /> {`Assisted with problem solving/goal setting`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTherapyBehavioral_2' name='cbTherapyBehavioral_2' className='add-only' value='EstablishedSafetyPlanCrisisManagement' /> {`Established safety plan/Crisis management`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTherapyBehavioral_3' name='cbTherapyBehavioral_3' className='add-only' value='DiscussedSymptomStressorManagement' /> {`Discussed symptom/stressor management`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTherapyBehavioral_4' name='cbTherapyBehavioral_4' className='add-only' value='DiscussedCbtTechniques' /> {`Discussed CBT/DBT techniques`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbTherapyBehavioral_5' name='cbTherapyBehavioral_5' className='add-only' value='ExpressiveTherapy' /> {`Expressive Therapy`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Substance Abuse`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstanceAbuse_1' name='cbSubstanceAbuse_1' className='add-only' value='EducationTreatmentOptionsForSubstanceAbuse' /> {`Education/Treatment options for substance abuse/dependency`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstanceAbuse_2' name='cbSubstanceAbuse_2' className='add-only' value='AssessedLevelOfMotivationForTreatment' /> {`Assessed level of motivation for SA treatment`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSubstanceAbuse_3' name='cbSubstanceAbuse_3' className='add-only' value='SmokingCessationTechniquesAndResources' /> {`Smoking cessation techniques and resources`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Resources and Follow-up`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbResourcesAndFollowup_1' name='cbResourcesAndFollowup_1' className='add-only' value='DiscussedCommunityResources' /> {`Discussed community resources`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbResourcesAndFollowup_2' name='cbResourcesAndFollowup_2' className='add-only' value='ReinforcedFollowupPlans' /> {`Reinforced follow-up plans`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbResourcesAndFollowup_3' name='cbResourcesAndFollowup_3' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtResourcesAndFollowupOther' name='txtResourcesAndFollowupOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Coordination of Care:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCoordinationOfCare_1' name='cbCoordinationOfCare_1' className='add-only' value='PatientChartReviewed' /> {`Patient's chart reviewed`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbCoordinationOfCare_2' name='cbCoordinationOfCare_2' className='add-only' value='CommunicationWithOtherProfessionalFamily' /> {`Communication with other Professional(s)/Family`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Patient Response to Interventions:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPatientResponseInterventions_1' name='cbPatientResponseInterventions_1' className='add-only' value='ExpressedFullUnderstand' /> {`Expressed full understand`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPatientResponseInterventions_2' name='cbPatientResponseInterventions_2' className='add-only' value='PatientAgreesWithTreatmentPlan' /> {`Patient agrees with treatment plan`}
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`PLAN:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPlan_1' name='cbPlan_1' className='add-only' value='DietExerciseEducation' /> {`Diet/Exercise Education`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPlan_2' name='cbPlan_2' className='add-only' value='OrderReviewDxStudies' /> {`Order/Review Dx Studies`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPlan_3' name='cbPlan_3' className='add-only' value='SummarizePriorRecords' /> {`Summarize Prior Records`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPlan_4' name='cbPlan_4' className='add-only' value='NutritionConsult' /> {`Nutrition Consult`}
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbPlan_5' name='cbPlan_5' className='add-only' value='OrderReviewLabs' /> {`Order/Review Labs`}
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='cbPlan_6' name='cbPlan_6' className='add-only' value='SubstanceAbuseCounselorConsult' /> {`Substance Abuse Counselor Consult`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPlan_7' name='cbPlan_7' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtPlanOther' name='txtPlanOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Follow-up:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbFollowUp_OneWeeks' name='rbFollowUp' className='add-only' value='OneWeeks' /> {`1-Week`}
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbFollowUp_WeeksTwo' name='rbFollowUp' className='add-only' value='WeeksTwo' /> {`2-Weeks`}
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbFollowUp_WeeksThree' name='rbFollowUp' className='add-only' value='WeeksThree' /> {`3-Weeks`}
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbFollowUp_MonthOne' name='rbFollowUp' className='add-only' value='MonthOne' /> {`1-Months`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbFollowUp_Other' name='rbFollowUp' className='add-only' value='Other' /> {`Other`}
                            &nbsp;<input type='text' id='txtFolloowUpOther' name='txtFolloowUpOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Service Order:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceOrder_1' name='cbServiceOrder_1' className='add-only' value='FamilyOutpatientServices' /> {`Family Outpatient Services`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceOrder_2' name='cbServiceOrder_2' className='add-only' value='CommunitySupport' /> {`Community Support`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceOrder_3' name='cbServiceOrder_3' className='add-only' value='GroupOutpatientServices' /> {`Group Outpatient Services`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceOrder_4' name='cbServiceOrder_4' className='add-only' value='IndividualOutpatientServices' /> {`Individual Outpatient Services`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceOrder_5' name='cbServiceOrder_5' className='add-only' value='CrisisIntervention' /> {`Crisis Intervention`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceOrder_6' name='cbServiceOrder_6' className='add-only' value='InteractiveComplexity' /> {`Interactive Complexity`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceOrder_7' name='cbServiceOrder_7' className='add-only' value='MedicationAdministration' /> {`Medication Administration`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceOrder_8' name='cbServiceOrder_8' className='add-only' value='DiagnosticAssessment' /> {`Diagnostic Assessment`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceOrder_9' name='cbServiceOrder_9' className='add-only' value='PsychologicalTesting' /> {`Psychological Testing`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceOrder_10' name='cbServiceOrder_10' className='add-only' value='NursingAssessmentCare' /> {`Nursing Assessment & Care`}
                        </td>
                        <td className='w-200'>
                            <input type='checkbox' id='cbServiceOrder_11' name='cbServiceOrder_11' className='add-only' value='PsychiatricTreatment' /> {`Psychiatric Treatment`}
                        </td>
                        <td className='w-300'>
                            <input type='checkbox' id='cbServiceOrder_12' name='cbServiceOrder_12' className='add-only' value='LegalSkillsCompetencyRestoration' /> {`Legal Skills / Competency Restoration`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServiceOrder_10' name='cbServiceOrder_10' className='add-only' value='BehavioralHealthAssessmentServicPlanDevelopment' /> {`Behavioral Health Assessment & Service Plan Development`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Continue with Order for Core Service(s) listed of Physician Service Order:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbContinueServiceListedPhysician_Yes' name='rbContinueServiceListedPhysician' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbContinueServiceListedPhysician_No' name='rbContinueServiceListedPhysician' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Additional Order for Service(s):`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbAdditionalOrderForService_Yes' name='rbAdditionalOrderForService' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbAdditionalOrderForService_No' name='rbAdditionalOrderForService' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`New Patient`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNewPatient_1' name='cbNewPatient_1' className='add-only' value='TwentyMinutes' /> {`99202 U1U6 (90805): (20 minutes)`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNewPatient_2' name='cbNewPatient_2' className='add-only' value='TenMinutes' /> {`99201 U1U6 (90862): (10 minutes)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNewPatient_3' name='cbNewPatient_3' className='add-only' value='FourtyFiveMinutes' /> {`99204 U1U6 (90807): (45 minutes)`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNewPatient_4' name='cbNewPatient_4' className='add-only' value='InitialDiagnostic' /> {`Initial Diagnostic (90792U1U6)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNewPatient_5' name='cbNewPatient_5' className='add-only' value='CrisisCode' /> {`Crisis Code (1ST 60mins)-(90839U1U6)`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNewPatient_6' name='cbNewPatient_6' className='add-only' value='CcAddOnEachAdditional' /> {`CC add on (each additional 30 mins)-(90840U1U6)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNewPatient_7' name='cbNewPatient_7' className='add-only' value='InteractiveComplexityInterpreters' /> {`Interactive complexity (interpreters & lang/imp) M.D. Assessment-(90785U1U6)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>{`Time In:`}</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>{`Time Out:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='time' id='txtNewPatient' name='txtNewPatient' className='add-only' />
                        </td>
                        <td className='w-200'><input type='time' id='txtNewPatientOne' name='txtNewPatientOne' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Established Patient`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEstablishedPatient_1' name='cbEstablishedPatient_1' className='add-only' value='FiveMinutes' /> {`99211 U1U6: (5 minutes)`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEstablishedPatient_2' name='cbEstablishedPatient_2' className='add-only' value='TenMinutes' /> {`99212 U1U6 (10 minutes)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEstablishedPatient_3' name='cbEstablishedPatient_3' className='add-only' value='FifteenMinutes' /> {`99213 U1U6 (90862): (15 minutes)`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEstablishedPatient_4' name='cbEstablishedPatient_4' className='add-only' value='TwentyFiveMinutes' /> {`99214 U1U6 (90805): (25 minutes)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbEstablishedPatient_5' name='cbEstablishedPatient_5' className='add-only' value='FourtyMinutes' /> {`99215 U1U6 (90807): (40 minutes)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>{`Time In:`}</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>{`Time Out:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='time' id='txtEstablishedPatient' name='txtEstablishedPatient' className='add-only' />
                        </td>
                        <td className='w-200'><input type='time' id='txtEstablishedPatientOne' name='txtEstablishedPatientOne' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Therapy E & M`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTherapyEm_1' name='cbTherapyEm_1' className='add-only' value='ThirtyMinutes' /> {`90833 U1U6 (30 + minutes)
`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTherapyEm_2' name='cbTherapyEm_2' className='add-only' value='FourtyFiveMinutes' /> {`90836U1U6 (45+ minutes)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTherapyEm_3' name='cbTherapyEm_3' className='add-only' value='SixteenThirtySevenMinutes' /> {`Non E/M/Therapy only90832 (16-37mins)`}
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTherapyEm_4' name='cbTherapyEm_4' className='add-only' value='ThirtyEightFiftyEightMinutes' /> {`Non E/M/Therapy only90834 (38-52mins)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbTherapyEm_5' name='cbTherapyEm_5' className='add-only' value='FiftyThreeMinutes' /> {`Non E/M/Therapy only 90837 (53+ mins)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>{`Time In:`}</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>{`Time Out:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><input type='time' id='txtTherapyEm' name='txtTherapyEm' className='add-only' />
                        </td>
                        <td className='w-200'><input type='time' id='txtTherapyEmOne' name='txtTherapyEmOne' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`REFERRALS:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReferrals_1' name='cbReferrals_1' className='add-only' value='Grn' /> {`GRN`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReferrals_2' name='cbReferrals_2' className='add-only' value='MarcusInst' /> {`Marcus Inst`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReferrals_3' name='cbReferrals_3' className='add-only' value='SaProgramGiven' /> {`S/A Program (# given)`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReferrals_4' name='cbReferrals_4' className='add-only' value='PsychTestingReferral' /> {`Psych Testing Referral`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReferrals_5' name='cbReferrals_5' className='add-only' value='Ifi' /> {`IFI`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReferrals_6' name='cbReferrals_6' className='add-only' value='ReferralAimsScale' /> {`Referral AIMS Scale`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReferrals_7' name='cbReferrals_7' className='add-only' value='Onevisit' /> {`1st visit`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReferrals_8' name='cbReferrals_8' className='add-only' value='Threemonths' /> {`3 months`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReferrals_9' name='cbReferrals_9' className='add-only' value='SixMonths' /> {`6 months`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReferrals_10' name='cbReferrals_10' className='add-only' value='NineMonths' /> {`9 months`}
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbReferrals_11' name='cbReferrals_11' className='add-only' value='Etc' /> {`etc`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbReferrals_12' name='cbReferrals_12' className='add-only' value='DiscontinuedCsiTherapyAsPerParent' /> {`Discontinued CSI/Therapy As Per Parent`}
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Labs Ordered:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbLabsOrdered_Yes' name='rbLabsOrdered' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbLabsOrdered_No' name='rbLabsOrdered' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Labs Received/Discussed:`}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <input type='radio' id='rbLabsRecievedDiscussed_Yes' name='rbLabsRecievedDiscussed' className='add-only' value='Yes' /> Yes
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbLabsRecievedDiscussed_No' name='rbLabsRecievedDiscussed' className='add-only' value='No' /> No
                        </td>
                    </tr>
                </table>












            </div>
        </form>

    )
} 